// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/jquery.splitter/css/jquery.splitter.css
// module id = 803
// module chunks = 1